import { Pipe, PipeTransform } from '@angular/core'
import { Booking } from '../../../booking/booking'
import { Store } from '@ngrx/store'
import { AppState } from '../../../../core/core.state'
import { productSelectors } from '../../../product/product.selectors'
import { map } from 'rxjs/operators'
import { Observable, of } from 'rxjs'

@Pipe({
  name: 'saleBookingLinkItemMap'
})
export class SaleBookingLinkItemMapPipe implements PipeTransform {
  transform(bookings: Booking[]): Observable<Booking[]> {
    if (!bookings) return of([])

    return this.productEntities$.pipe(
      map((productEntities) => {
        return bookings.map((booking) => {
          return {
            ...booking,
            description: booking.description
              ? `${booking.id} - ${booking.description} - ${
                  productEntities[booking.productId]?.description
                }`
              : `${booking.id} - ${
                  productEntities[booking.productId]?.description
                }`
          }
        })
      })
    )
  }

  constructor(private store: Store<AppState>) {}

  productEntities$ = this.store.select(productSelectors.selectEntities)
}
